import { render, staticRenderFns } from "./reservation-message.vue?vue&type=template&id=37f36c7d&scoped=true&"
import script from "./reservation-message.vue?vue&type=script&lang=ts&"
export * from "./reservation-message.vue?vue&type=script&lang=ts&"
import style0 from "./reservation-message.vue?vue&type=style&index=0&id=37f36c7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f36c7d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText,VCardTitle})
